/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  products: {},
  error: null,
};

const getters = {
  products: state => state.products,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `superadmin/${payload.user.data.id}`;
    Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/zones/${payload.id}/products/list`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, products) {
    state.products = products.data;
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.products = [];
  },
  [mTypes.DATA_ERROR](state, response) {
    state.error = response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/zones/products.js